import { render, staticRenderFns } from "./VisitCardMessage.vue?vue&type=template&id=349068ac&scoped=true&"
import script from "./VisitCardMessage.vue?vue&type=script&lang=js&"
export * from "./VisitCardMessage.vue?vue&type=script&lang=js&"
import style0 from "./VisitCardMessage.vue?vue&type=style&index=0&id=349068ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349068ac",
  null
  
)

export default component.exports